<template>
  <div class="worker">
    <el-card class="box-card" shadow="never">
      <el-form ref="form" :inline="true">
        <el-form-item><el-button type="primary" @click="showAddDiloag('新增人员')">添加</el-button></el-form-item>
      </el-form>

      <el-table :data="tableData" border style="width: 100%;margin-top:10px;">
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="userName" label="人员" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="180">
          <template slot-scope="{ row }">
            <span>{{ typeList[row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="projectNames" label="项目" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button @click="deleteUser(scope.row)" type="text" size="small">删除</el-button>
            <el-button @click="showAddDiloag(scope.row)" type="text" size="small">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 添加角色 -->
    <Dialog ref="dlgAddRole" :title="dlgTitle">
      <el-form ref="roleForm" :model="workerData" label-width="100px" :rules="rules">
        <el-form-item label="人员:" prop="userId">
          <el-select v-model="userId" @change="onSelectUser" filterable style="width: 100%;">
            <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.username"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型:" prop="type">
          <el-select v-model="workerData.type" style="width: 100%;" :disabled="isUpdae">
            <el-option v-for="(item, index) in idList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目权限:">
          <el-checkbox-group v-model="projectIds">
            <el-checkbox v-for="item in workerData.managerProjectDetailVoList" :key="item.projectId" :label="item.projectId" name="type">{{ item.projectName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item style="text-align:right" class="btn-tools"><el-button class="btn" type="primary" @click="addUserProjectManager">保存</el-button></el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>
<script>
import ROLEAPI from '@/api/role';
import GROUPAPI from '@/api/group';
import WORKERAPI from '@/api/worker';
import { setToken, removeToken, setInfo, getInfo } from '@/utils/auth';
import Dialog from '@/components/dialog';
export default {
  components: {
    Dialog
  },
  data() {
    return {
      typeList: ['无', '工单管理人员','工单运维人员'],
      idList: [{ label: '工单管理人员', value: 1 }, { label: '工单运维人员', value: 2 }],
      dlgTitle: '新增人员',
      projectIds: [],
      userId: '', //用户ID
      userList: [], //用户列表
      form: {
        type: 1
      },
      rules: {
        roleName: [
          {
            required: true,
            message: '角色名称不能为空',
            trigger: 'blur'
          }
        ]
      },
      tableData: [],
      projectList: [],
      workerData: { type: 1 },
      isUpdae:false
    };
  },
  methods: {
    //初始化
    init() {
      this.searchManagerList();
      this.searchAllUser();
    },
    //触发切换用户事件
    onSelectUser(id) {
      let params = { type: 1, userId: id };
      let self = this;
      this.userId = id;
      WORKERAPI.searchManagerProjectDetail(params).then(res => {
        if (res.data.code == 200) {
          this.workerData = res.data.data;
          this.workerData.type = 1;
          this.projectIds = [];
          this.workerData.managerProjectDetailVoList.forEach(item => {
            if (item.isChecked) {
              this.projectIds.push(item.projectId);
            }
          });
        }
      });
    },
    //获取所有用户
    searchAllUser() {
      WORKERAPI.searchAllUser().then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data;
        }
      });
    },
    //检索管理人员列表
    searchManagerList() {
      this.tableData = [];
      let params = this.form;
      WORKERAPI.searchManagerList().then(res => {
        this.tableData = res.data.data;
      });
    },
    //显示对话框
    showAddDiloag(name) {
      if (typeof name == 'string') {
        this.userId = '';
        this.projectIds = [];
        this.workerData.type = 1; //默认工单
        this.dlgTitle = name;
        this.isUpdae = false;
      } else {
        this.userId = name.userId;
        this.dlgTitle = '修改人员';
        this.isUpdae = true;
        this.onSelectUser(this.userId);
      }
      this.$refs.dlgAddRole.open();
    },
    //删除角色
    deleteUser(row) {
      let self = this;
      this.userId = '';
      this.$confirm('确定要执行此操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          WORKERAPI.deleteByUser({
            type: 1,
            userId: row.userId
          }).then(res => {
            this.$message.success('操作成功');
            self.searchManagerList();
          });
        })
        .catch(() => {});
    },
    //保存提交
    addUserProjectManager() {
      if (!this.userId) {
        this.$message.error('请选择用户');
        return false;
      }
      let params = { projectIds: this.projectIds, type: this.workerData.type, userId: this.userId };
      WORKERAPI.addUserProjectManager(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchManagerList();
          this.$refs.dlgAddRole.close();
        }
      });
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.worker {
}
</style>



// WEBPACK FOOTER //
// src/views/boss/worker/index.vue